import WindowFactory from '@/factory/window'

export default {
  setWindows(state, value) {
    state.windows = value
  },
  appendWindow(state, value) {
    state.windows.unshift(value)
  },
  deleteWindowByIndex(state, index) {
    if (state.windows[index].status !== WindowFactory.CREATE) {
      state.windows[index].status = WindowFactory.DELETE
    } else {
      state.windows.splice(index, 1)
    }
  },
  deleteScheduleByWindowAndIndex(state, payload) {
    const window = state.windows[payload.windowIndex]
    if (window.schedule[payload.scheduleIndex]) {
      window.schedule.splice(payload.scheduleIndex, 1)
      this.commit('_updateWindowStatus', window)
    }
  },
  appendScheduleByWindowIndex(state, payload) {
    const window = state.windows[payload.index]
    window.schedule.push(payload.schedule)
    this.commit('_updateWindowStatus', window)
  },
  updateWindowFieldByIndex(state, payload) {
    const window = state.windows[payload.index]
    window[payload.key] = payload.value
    if (payload.withUpdate) {
      this.commit('_updateWindowStatus', window)
    }
  },
  updateWindowDuration(state, payload) {
    const window = state.windows[payload.windowIndex]
    window.schedule[payload.scheduleIndex] = payload.value
    if (window.status !== WindowFactory.CREATE) {
      this.commit('_updateWindowStatus', window)
    }
  },
  _updateWindowStatus(state, window) {
    if (window.status !== WindowFactory.CREATE) {
      window.status = WindowFactory.UPDATE
    }
  },
}
